var PLAYER_TAGS = {
  GET_PLAYER_PROFILE: 'PlayerProfile',
  CASINO_DOLLAR_BALLANCE: 'CasinoDollarBalance'
};
PLAYER_TAGS.playerTagsArray = Object.values(PLAYER_TAGS);
export { PLAYER_TAGS };